import { on } from 'delegated-events'
import requestTimeout from '../common/requestTimeout'
import qs from 'qs'
import { generateUrl } from '@common/util'

const fn = {
  init: () => {
    fn.bindEvents()

    fn.form = document.querySelector('.filter-form')

    fn.CLASS_NAMES = {
        active: 'is-active',
        opened: 'is-opened',
        trigger: 'js-toggle-trigger'
      }

    fn.props = {
        $toggles: document.querySelectorAll('[data-toggle]')
      }

    let practiceItems = document.querySelectorAll('.practice-item');
    practiceItems.forEach((el, index) => {
        let gridRowStartValue = Math.floor(index / 3) + 1;
        el.nextElementSibling.style.gridRowStart = gridRowStartValue;
    });

    fn.props.$toggles.forEach(($toggle) => {
        const $target = document.querySelector($toggle.dataset.toggleTarget)

        if ($toggle.classList.contains(fn.CLASS_NAMES.active) && $target) {
            $target.style.height = `${$target.scrollHeight}px`
            $target.classList.add(fn.CLASS_NAMES.opened)

            fn.bindTabListHeightUpdate($target)
        }

        if ($toggle.classList.contains('view-details-trigger')) {
            $toggle.addEventListener('click', (e) => {
                e.preventDefault();

                // closest practice-item
                const practiceID = e.target.getAttribute('data-practice');
                let currentPractice = document.querySelector(`.${practiceID}`);
                currentPractice.classList.toggle('!hidden');

                const toggleTargetId = e.target.getAttribute('data-toggle-target');
                const toggleTarget = document.querySelector(toggleTargetId);
                let activeTab = toggleTarget.querySelector('[aria-hidden="false"]');

                requestTimeout(() => {
                    toggleTarget.classList.toggle('opacity-0');

                    if (activeTab.classList.contains('opacity-0')) {
                        activeTab.classList.remove('opacity-0');
                    }

                    if (toggleTarget.classList.contains('is-active')) {
                        let activeTabHeight = activeTab.scrollHeight;
                        $target.style.height = `${$target.scrollHeight + activeTabHeight - 36}px`
                    }
                }, 1);

                document.querySelectorAll('.js-toggle-target.grid-practice-item').forEach(item => {
                    if (item !== toggleTarget) {
                        item.classList.add('hidden');
                        item.classList.add('opacity-0');
                        item.classList.remove('is-active');
                        item.classList.remove('is-opened');
                        item.style.height = 0;

                        const itemPracticeID = item.querySelector('.view-details-trigger').getAttribute('data-practice');
                        let itemPractice = document.querySelector(`.${itemPracticeID}`);
                        itemPractice.classList.remove('!hidden');
                    }
                });

                toggleTarget.classList.remove('hidden');
            });
        }
    })

    on('click', '.view-toggle:not([disabled])', fn.handleViewToggle)
    on('change', '#sort', fn.handleSortToggle)
    on('click', '.sidebar-toggle', fn.handleSidebarToggle)
  },

  bindEvents: () => {
    on('click', '[data-toggle]', fn.handleClick)
  },

  handleClick: (e) => {
    e.preventDefault()

    const $trigger = e.target.closest('[data-toggle]')
    const $target = document.querySelector($trigger.dataset.toggleTarget)

    if ($trigger && $target) {
      fn.toggle($trigger, $target)
    }
  },

  bindTabListHeightUpdate: ($target) => {
    if (!$target.classList.contains('PracticeTabList') && !$target.classList.contains('GridPracticeTabList')) {
      return
    }

    const targetId = $target.id

    on('click', `#${targetId} [role="tab"]`, () => {
      requestTimeout(() => {
        $target.style.height = 'auto'
        $target.style.height = `${$target.scrollHeight}px`
      }, 0)
    })
  },

  expand: ($trigger, $target) => {
    fn.handleGroup($trigger)

    const $originalTrigger = fn.getOriginalTrigger($trigger)

    if ($originalTrigger) {
      $originalTrigger.classList.add(fn.CLASS_NAMES.active)
    }

    $target.classList.add(fn.CLASS_NAMES.active)

    let svg = $trigger.querySelector('svg.icon');
    if (svg) {
        svg.style.transform = 'rotate(180deg)';
    }

    if ($target.classList.contains('PracticeTabList') || $target.classList.contains('GridPracticeTabList')) {
        let activeTab = $target.querySelector('[aria-hidden="false"]')

        activeTab.classList.remove("opacity-0");

        fn.bindTabListHeightUpdate($target)
    }

    $target.style.height = `${$target.scrollHeight}px`

    // Handle practice details toggle for the item
    let initialHeight = null;

    if ($target.classList.contains('grid-practice-item')) {
        if (initialHeight === null) {
            initialHeight = parseInt($target.style.height);
        }

        on('click', `#${$target.id} [role="tab"]`, () => {
            let activeTabListHeight = $target.querySelector('[aria-hidden="false"]').scrollHeight;
            $target.style.height = `${initialHeight + activeTabListHeight - 36}px`;
        });
    }

    requestTimeout(() => {
      $target.classList.add(fn.CLASS_NAMES.opened)
    }, 400)
  },

  collapse: ($trigger, $target) => {
    const $originalTrigger = fn.getOriginalTrigger($trigger)

    if ($originalTrigger) {
      $originalTrigger.classList.remove(fn.CLASS_NAMES.active)
    }

    let svg = $trigger.querySelector('svg.icon');
    if (svg) {
        svg.style.transform = 'rotate(0deg)';
    }

    $target.classList.remove(fn.CLASS_NAMES.active)
    $target.classList.remove(fn.CLASS_NAMES.opened)
    $target.style.height = 0

    requestTimeout(() => {
      $target.style.removeProperty('height')
    }, 350)

    if ($target.classList.contains('grid-practice-item')) {
        requestTimeout(() => {
            $target.classList.add('hidden');
        }, 250);
    }

    if ($target.classList.contains('PracticeTabList') || $target.classList.contains('GridPracticeTabList')) {
        let activeTab = $target.querySelector('[aria-hidden="false"]')
        activeTab.classList.add("opacity-0");
    }
  },

  toggle: ($trigger, $target) => {
    $target.classList.contains(fn.CLASS_NAMES.active)
      ? fn.collapse($trigger, $target)
      : fn.expand($trigger, $target)
  },

  getOriginalTrigger: ($trigger) => {
    return document.querySelector(`[data-toggle-target="${$trigger.dataset.toggleTarget}"].${fn.CLASS_NAMES.trigger}`)
  },

  handleGroup: ($trigger) => {
    const toggleGroup = $trigger.dataset.toggleGroup

    if (toggleGroup) {
      const $expanded = document.querySelectorAll(`[data-toggle-group="${toggleGroup}"].${fn.CLASS_NAMES.active}`)

      $expanded.forEach(($trigger) => {
        const $target = document.querySelector($trigger.dataset.toggleTarget)
        fn.collapse($trigger, $target)
      })
    }
  },

  handleViewToggle: (e) => {
    const selectedView = e.currentTarget.dataset.view

    const toggles = document.querySelectorAll('.view-toggle')
    const practiceContent = document.querySelector('.practice-contents')
    const button = document.querySelector(`.view-toggle[data-view="${selectedView}"]`)

    practiceContent.classList.remove('as-grid', 'as-list')
    practiceContent.classList.add(`as-${selectedView}`)

    toggles.forEach((x) => {
      x.disabled = false
      x.setAttribute('aria-pressed', 'false')
    })

    button.setAttribute('aria-pressed', 'true')
    button.disabled = true

    const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    currentParams.view = selectedView

    const url = generateUrl(fn.form, currentParams)

    window.history.replaceState({}, '', url)
  },

  handleSortToggle: (e) => {
    const selectedSort = e.currentTarget.value

    const currentParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    currentParams.sort = selectedSort
    delete currentParams.practiceID

    const url = generateUrl(fn.form, currentParams, true)

    window.location.href = url
  },

  handleSidebarToggle: (e) => {
    e.preventDefault()

    let target = e.currentTarget;
    let sidebar = document.querySelector(target.dataset.sidebarToggleTarget);
    let searchResultsWrapper = document.querySelector('.search-results-wrapper');
    let sidebarToggle = document.querySelector('.sidebar-toggle');
    let filtersLabel = document.querySelector('.filters-label');

    target.classList.toggle('collapsed');

    filtersLabel.classList.toggle('!w-0');
    filtersLabel.classList.toggle('opacity-0');
    sidebarToggle.classList.toggle('!w-full');

    sidebar.classList.toggle('!w-0');
    sidebar.classList.toggle('!h-0');
    sidebar.classList.toggle('invisible');
    sidebar.classList.toggle('opacity-0');
    sidebar.classList.toggle('overflow-hidden');

    searchResultsWrapper.classList.toggle('!gap-0');
  },
}

export default {
  can: () => document.querySelectorAll('[data-toggle]').length,
  run: fn.init
}
